export default __webpack_public_path__ + "images/chatbot.4c7758cad8048e3acfc8ba7cc3c0745a.png";